import App from "@bloglovin/inspire-engine/App";

const STUDIO_APP = "CreatorStudio";
const APP_BUILDER = "AppBuilder";
const refId = value => Number(value?.id ?? value?.pk?.id ?? value) || 0;

// Before the Studio engine has booted there is nothing to look up yet, so 0 ("not a destination's app").
const appOrNull = appName => {
  try {
    return App.get(appName);
  } catch (_error) {
    return null;
  }
};
const studioOrNull = () => appOrNull(STUDIO_APP);

export function customAppIdOf(destinationId) {
  return refId(studioOrNull()?.getEntityField("Destination", { id: Number(destinationId) }, "customAppId"));
}

// The app's own link is loaded wherever App Builder shows it; the Destination scan covers links seen from Studio.
export function destinationOfApp(appId) {
  const builder = appOrNull(APP_BUILDER);
  const pk = { id: Number(appId) };
  // Store-only read: getEntityField would fetch (and re-hydrate) the app, stealing focus on a fresh create.
  const linked = builder?.hasEntity("BuilderApp", pk) ? refId(builder.getEntityFieldData("BuilderApp", pk)?.destinationId) : 0;
  if (linked > 0) {
    return linked;
  }
  const studio = studioOrNull();
  const match = (studio?.getAllRawEntitiesOfType("Destination") ?? []).find(raw => refId(raw.fieldData?.customAppId) === Number(appId));
  return match ? refId(match.fieldData?.id ?? match.pk) : 0;
}
